import { render, staticRenderFns } from "./createnft.vue?vue&type=template&id=4bec5d1a&lang=pug"
import script from "./createnft.vue?vue&type=script&lang=js"
export * from "./createnft.vue?vue&type=script&lang=js"
import style0 from "./createnft.vue?vue&type=style&index=0&id=4bec5d1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports